import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_59de254c from 'nuxt_plugin_plugin_59de254c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_67ebf269 from 'nuxt_plugin_vuesocialsharingplugin_67ebf269' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_dayjsplugin_7b50cb6d from 'nuxt_plugin_dayjsplugin_7b50cb6d' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_c10f266a from 'nuxt_plugin_pluginutils_c10f266a' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_5910f356 from 'nuxt_plugin_pluginrouting_5910f356' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_1c7ea7d9 from 'nuxt_plugin_pluginmain_1c7ea7d9' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_ce0e6120 from 'nuxt_plugin_axios_ce0e6120' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginclient_2d6f0854 from 'nuxt_plugin_pluginclient_2d6f0854' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_4f01ed5e from 'nuxt_plugin_pluginserver_4f01ed5e' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_calliaui_b856d912 from 'nuxt_plugin_calliaui_b856d912' // Source: ../../../plugins/calliaui.js (mode: 'all')
import nuxt_plugin_lodash_5d4c7b8c from 'nuxt_plugin_lodash_5d4c7b8c' // Source: ../../../plugins/lodash.js (mode: 'all')
import nuxt_plugin_frontchat_bf3f1868 from 'nuxt_plugin_frontchat_bf3f1868' // Source: ../../../plugins/frontchat.js (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../../../plugins/i18n.js (mode: 'all')
import nuxt_plugin_buttercms_7abe0884 from 'nuxt_plugin_buttercms_7abe0884' // Source: ../../../plugins/buttercms.js (mode: 'all')
import nuxt_plugin_amplify_900d1ace from 'nuxt_plugin_amplify_900d1ace' // Source: ../../../plugins/amplify.js (mode: 'all')
import nuxt_plugin_routerguards_adb5328a from 'nuxt_plugin_routerguards_adb5328a' // Source: ../../../plugins/router-guards.js (mode: 'all')
import nuxt_plugin_jsonld_2ff766e1 from 'nuxt_plugin_jsonld_2ff766e1' // Source: ../../../plugins/jsonld.js (mode: 'all')
import nuxt_plugin_fontawesome_b8db358e from 'nuxt_plugin_fontawesome_b8db358e' // Source: ../../../plugins/fontawesome.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Best Experience Sending Flowers & Gifts in Canada | Callia","htmlAttrs":{"lang":"en"},"__dangerouslyDisableSanitizers":["script"],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"hid":"description","name":"description","content":"Rated 4.9\u002F5 stars. Loved by 300,000+ people. Order fast, easy & same day picture-perfect bouquets exactly like the photo. Always fresh, on-time & guaranteed. Shop now."},{"name":"format-detection","content":"telephone=no"},{"name":"callia-release-id","content":"V3-v3.45.6"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon_callia.png"},{"rel":"preconnect dns-prefetch","href":"https:\u002F\u002Fapi.config-security.com\u002F","crossorigin":true},{"rel":"preconnect dns-prefetch","href":"https:\u002F\u002Fconf.config-security.com\u002F","crossorigin":true},{"rel":"preconnect dns-prefetch","href":"https:\u002F\u002Fwhale.camera\u002F","crossorigin":true},{"rel":"stylesheet","href":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Ffont-awesome\u002F6.5.1\u002Fcss\u002Fall.min.css"}],"script":[{"async":true,"src":"https:\u002F\u002Fmaps.googleapis.com\u002Fmaps\u002Fapi\u002Fjs?key=AIzaSyAq-uum17ngDp9UVIv49_bh7hvKGEEZALc&libraries=places&loading=async&callback=initMap","body":true},{"innerHTML":"window.initMap = function() {\n          console.log('Google Maps API loaded');\n        };"},{"type":"text\u002Fjavascript","innerHTML":"\n        (function (w, d, s, l, i) {\n          w[l] = w[l] || [];\n          w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});\n          var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';\n          j.async = true;\n          j.src = 'https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);\n        })(window, document, 'script', 'dataLayer', 'GTM-PVG28J4');\n        "},{"type":"text\u002Fjavascript","innerHTML":"\n        (function (url) {\n          \u002F*Tracking Bootstrap Set Up DataLayer objects\u002Fproperties here*\u002F\n          if (!window.DataLayer) {\n            window.DataLayer = {};\n          }\n          if (!DataLayer.events) {\n            DataLayer.events = {};\n          }\n          DataLayer.events.SPIVersion = DataLayer.events.SPIVersion || \"3.4.1\";\n          DataLayer.events.SiteSection = \"1\";\n\n          var loc,\n            ct = document.createElement(\"script\");\n          ct.type = \"text\u002Fjavascript\";\n          ct.async = true;\n          ct.src = url;\n          loc = document.getElementsByTagName(\"script\")[0];\n          loc.parentNode.insertBefore(ct, loc);\n        })(document.location.protocol + \"\u002F\u002Ftag.rmp.rakuten.com\u002F124297.ct.js\");\n        "},{"innerHTML":"\n        (function(h,o,u,n,d) {\n          h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}\n          d=o.createElement(u);d.async=1;d.src=n\n          n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)\n        })(window,document,'script','https:\u002F\u002Fwww.datadoghq-browser-agent.com\u002Fdatadog-rum-v4.js','DD_RUM')\n        DD_RUM.onReady(function() {\n          DD_RUM.init({\n            clientToken: 'pubadd36b0e5025edc7916c37ce1601997e',\n            applicationId: '0178b892-2ba0-40d3-a974-1525355f5b92',\n            site: 'datadoghq.com',\n            service:'callia.com',\n            env:'prod',\n            version: 'V3-v3.45.6',\n            sampleRate: 100,\n            trackInteractions: true,\n            defaultPrivacyLevel: 'mask-user-input'\n          });\n          DD_RUM.startSessionReplayRecording();\n        })"},{"innerHTML":"\n        window.TriplePixelData = {\n          TripleName: \"callia-flowers.myshopify.com\",\n          ver: \"2.12\",\n          plat: \"SHOPIFY\",\n          isHeadless: true\n        },\n        function(W, H, A, L, E, _, B, N) {\n          function O(U, T, P, H, R) {\n            void 0 === R && (R = !1),\n            H = new XMLHttpRequest,\n            P ? (H.open(\"POST\", U, !0), H.setRequestHeader(\"Content-Type\", \"text\u002Fplain\")) : H.open(\"GET\", U, !0),\n            H.send(JSON.stringify(P || {})),\n            H.onreadystatechange = function() {\n              4 === H.readyState && 200 === H.status ? (R = H.responseText, U.includes(\".txt\") ? eval(R) : P || (N[B] = R)) : (299 \u003C H.status || H.status \u003C 200) && T && !R && (R = !0, O(U, T - 1, P))\n            }\n          }\n          if (N = window, !N[H + \"sn\"]) {\n            N[H + \"sn\"] = 1,\n            L = function() {\n              return Date.now().toString(36) + \"_\" + Math.random().toString(36)\n            };\n            try {\n              A.setItem(H, 1 + (0|A.getItem(H) || 0)),\n              (E = JSON.parse(A.getItem(H + \"U\") || \"[]\")).push({u: location.href, r: document.referrer, t: Date.now(), id: L()}),\n              A.setItem(H + \"U\", JSON.stringify(E))\n            } catch(e) {}\n            var i, m, p;\n            A.getItem('\"!nC`') || (_ = A, A = N, A[H] || (E = A[H] = function(t, e, a) {\n              return void 0 === a && (a = []), \"State\" == t ? E.s : (W = L(), (E._q = E._q || []).push([W, t, e].concat(a)), W)\n            },\n            E.s = \"Installed\",\n            E._q = [],\n            E.ch = W,\n            B = \"configSecurityConfModel\",\n            N[B] = 1,\n            O(\"https:\u002F\u002Fconf.config-security.com\u002Fmodel\", 5),\n            i = L(),\n            m = A[atob(\"c2NyZWVu\")],\n            _.setItem(\"di_pmt_wt\", i),\n            p = {\n              id: i,\n              action: \"profile\",\n              avatar: _.getItem(\"auth-security_rand_salt_\"),\n              time: m[atob(\"d2lkdGg=\")] + \":\" + m[atob(\"aGVpZ2h0\")],\n              host: A.TriplePixelData.TripleName,\n              plat: A.TriplePixelData.plat,\n              url: window.location.href,\n              ref: document.referrer,\n              ver: A.TriplePixelData.ver\n            },\n            O(\"https:\u002F\u002Fapi.config-security.com\u002Fevent\", 5, p),\n            O(\"https:\u002F\u002Fwhale.camera\u002Flive\u002Fdot.txt\",5)))\n          }\n        }(\"\", \"TriplePixel\", localStorage);\n        "},{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fpolyfill\u002Fv3\u002Fpolyfill.min.js?version=4.8.0&features=es2015%2Ces2016%2Ces2017%2Ces2018%2Ces2019%2Ces2020%2Ces2021%2Ces2022%2Ces2023%2CElement.prototype.matches","crossorigin":"anonymous","attrs":{"ua":"ie\u002F11.0.0"}}],"noscript":[{"innerHTML":"\n        \u003Ciframe src=\"https:\u002F\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-PVG28J4\" height=\"0\" width=\"0\"\n        style=\"display:none;visibility:hidden\"\u003E\u003C\u002Fiframe\u003E\n        "}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_59de254c === 'function') {
    await nuxt_plugin_plugin_59de254c(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_67ebf269 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_67ebf269(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_7b50cb6d === 'function') {
    await nuxt_plugin_dayjsplugin_7b50cb6d(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_c10f266a === 'function') {
    await nuxt_plugin_pluginutils_c10f266a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_5910f356 === 'function') {
    await nuxt_plugin_pluginrouting_5910f356(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_1c7ea7d9 === 'function') {
    await nuxt_plugin_pluginmain_1c7ea7d9(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_ce0e6120 === 'function') {
    await nuxt_plugin_axios_ce0e6120(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_2d6f0854 === 'function') {
    await nuxt_plugin_pluginclient_2d6f0854(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_4f01ed5e === 'function') {
    await nuxt_plugin_pluginserver_4f01ed5e(app.context, inject)
  }

  if (typeof nuxt_plugin_calliaui_b856d912 === 'function') {
    await nuxt_plugin_calliaui_b856d912(app.context, inject)
  }

  if (typeof nuxt_plugin_lodash_5d4c7b8c === 'function') {
    await nuxt_plugin_lodash_5d4c7b8c(app.context, inject)
  }

  if (typeof nuxt_plugin_frontchat_bf3f1868 === 'function') {
    await nuxt_plugin_frontchat_bf3f1868(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (typeof nuxt_plugin_buttercms_7abe0884 === 'function') {
    await nuxt_plugin_buttercms_7abe0884(app.context, inject)
  }

  if (typeof nuxt_plugin_amplify_900d1ace === 'function') {
    await nuxt_plugin_amplify_900d1ace(app.context, inject)
  }

  if (typeof nuxt_plugin_routerguards_adb5328a === 'function') {
    await nuxt_plugin_routerguards_adb5328a(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_2ff766e1 === 'function') {
    await nuxt_plugin_jsonld_2ff766e1(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_b8db358e === 'function') {
    await nuxt_plugin_fontawesome_b8db358e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
